import React from 'react';
import BNRathiLogo from "../../assets/images/BNRathiLogo.png";
import { Col } from 'reactstrap';

const LoginPageLogo = () => {
    return (
        <React.Fragment>
           <Col
                        xxl={6}
                        xl={6}
                        lg={6}
                        md={6}
                        sm={12}
                        className="p-0 m-0"
                      >
                        <div
                          className="d-flex align-items-center justify-content-center w-100 h-100 p-5"
                          style={{ backgroundColor: "#F1F4F7" }}
                        >
                          <img
                            src={BNRathiLogo}
                            alt="B.N. Rathi logo"
                            className="login_responsive_logo"
                          />
                        </div>
                      </Col>
        </React.Fragment>
    );
};

export default LoginPageLogo;